import EquifaxReport from "../../../jsx/components/Dashboard/EquifaxReport/EquifaxReport";

const EquifaxReportsWrapper = () => {
  return <EquifaxReport />;
};

export default constore(EquifaxReportsWrapper);
